import type { PropsWithChildren } from "react";
import { createContext } from "react";
import type { AccessCategory, ClientDictionaries } from "../../api/types/settingsTypes";

interface ContextValue {
  accessCategories: AccessCategory[];
  dictionaries: ClientDictionaries;
  loading: boolean;
}

const SettingsContext = createContext<ContextValue | undefined>(undefined);

export const SettingsContextProvider = ({
  accessCategories,
  dictionaries,
  loading,
  children,
}: PropsWithChildren<ContextValue>) => {
  return <SettingsContext value={{ accessCategories, dictionaries, loading }}>{children}</SettingsContext>;
};

export default SettingsContext;
